<template>
  <div class="card border-radius-none">
    <div class="commandes__ligne commandes__ligne--border-width">

      <div class="commandes__ligne-selecteurs">
        <b-icon class="drag" icon="drag"
                  :class="{
                    'pointer-no-drop' : disabledDraggable,
                    'draggable-handle' : !disabledDraggable
                  }">
        </b-icon>
        <b-checkbox v-model="ligneCommande.selected">
        </b-checkbox>
      </div>

      <div class="commandes__ligne-libelle">
        <b-field :type="typeLibelle">
          <b-input v-model="ligneCommande.libelle" type="textarea" :rows="nbLignesLibelle">
          </b-input>
        </b-field>
      </div>

      <div class="commandes__fin-ligne" style='--margin-top: .4em;'>
        <div class="has-text-weight-semibold">
            <span v-if="ligneCommande.totalHt" class="is-fullwidth ellipsis">
              {{ligneCommande.totalHt | formatDevise}}
            </span>
          <span v-else> {{ 0.00 | formatDevise }} </span>
        </div>
        <div></div>
        <a @click="supprimerProduit()">
          <b-icon
            icon="delete-forever"
            type="is-danger">
          </b-icon>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import gestionType from '@/services/general/gestionType';
import inProgress from '@/services/general/inProgress';

export default {
  name: 'DevisCommandesEditSousTotal',
  props: {
    lignesCommande: Array,
    ligneCommande: Object,
    error: Boolean,
    disabledDraggable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    nbLignesLibelle() {
      if (this.ligneCommande.libelle) {
        return this.ligneCommande.libelle.split('\n').length;
      }
      return 1;
    },
    typeLibelle() {
      return gestionType(this.ligneCommande.libelle, this.error);
    },
  },
  methods: {
    supprimerProduit() {
      this.lignesCommande.splice(this.lignesCommande.indexOf(this.ligneCommande), 1);
      this.$emit('reloadTotalHt');
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
};
</script>

<style>

</style>
